import { type ResourcesConfig } from 'aws-amplify'
import { environment } from 'src/environments/environment'

// Define OAuthProvider type locally since it's not exported in AWS Amplify v6 public API
type OAuthProvider = 'Google' | 'Facebook' | 'Amazon' | 'Apple'

const config: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: environment.USER_POOL_ID,
      userPoolClientId: environment.USER_POOL_CLIENT_ID,
      loginWith: {
        email: true,
        oauth: {
          domain: environment.DOMAIN,
          scopes: environment.SCOPES,
          providers: environment.PROVIDERS as OAuthProvider[],
          redirectSignIn: environment.REDIRECT_SIGN_IN,
          redirectSignOut: environment.REDIRECT_SIGN_OUT,
          responseType: environment.RESPONSE_TYPE as 'code' | 'token',
        },
      },
    },
  },
}
export default config
